// send tracking events to the api
import md5 from 'crypto-js/md5';
import Api from './Api';

export function trackNewsHit(slug) {
    Api.post('api/v1/tracking/newsHit', { slug })
        .then((/* response */) => {
            // console.log("tracking response", response)
        })
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.log('error when tracking news hit, error:', error);
        });
}

export function trackTagHit(tag) {
    Api.post('api/v1/tracking/tagHit', { tag })
        .then((/* response */) => {
            // console.log("tag tracking response", response)
        })
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.log('error when tracking tag hit, error:', error);
        });
}

export function createBrowserHash() {
    // create a (pretty) unique hash that can be used to identify the user(s browser)
    const hash = (+new Date() + Math.random()).toString(36);

    return md5(hash).toString();
}

export function createSessionHash() {
    // create a (pretty) unique hash that can be used to identify the users session.
    // we could combine this with the browserHash to try to add some more integrity (maybe? :D)
    const hash = (+new Date() + Math.random()).toString(36);

    return md5(hash).toString();
}
